enum RoutePath {
  NOTEPAD = "notepad",
  FILES = "files",
  ENVIRONMENTS = "environments",
  REPORTS = "reports",
  SQL = "sql",
  DASHBOARDS = "dashboards",
  APPS = "apps",
  APP = "app",
  SETTINGS = "settings",
  WORKFLOWS = "workflows",
  WORKSHEETS = "analysis-worksheets",
}

export default RoutePath;
